import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { AppService } from './app.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private  appService: AppService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    const teams_id = localStorage.getItem('teams_id');
    const headers = {};
    const _clone: any = {};

    if (token) { 
      headers['Authorization'] = `Bearer ${token}`; 
      this.appService.setCookie('tutored-employer', token, 365);
    }
    if (teams_id) { headers['X-Team'] = teams_id; }

    _clone.setHeaders = headers;

    if (window['publicTestConfig'] && window['publicTestConfig']['case'] !== null && request.url.indexOf('career-day') > -1) {
      // headers['X-Case'] = window['publicTestConfig']['X-Case'];
      _clone.setParams = {'case': window['publicTestConfig']['case']}

    }

    request = request.clone(_clone);

    return next.handle(request);
  }
}
